export const infoUs = [
    {
        image: 'bg-hamburguesaGanadora',
        name: 'FESTIVAL HAMBURGUESA DORADA',
        description: 'En el año 2022, fuimos honrados con el prestigioso premio a la Mejor Hamburguesa de La Dorada, Caldas. Este reconocimiento fue otorgado por votación popular durante el Festival de la Hamburguesa Dorada, un evento destacado organizado por la Cámara de Comercio de La Dorada.'
    },
    {
        image: 'bg-kolozoGastrobar',
        name: 'JUNGLA GASTRONOMICA Y MUSICAL',
        description: 'Kolozo es una jungla en las alturas donde se une la gastronomía, la mixología y la buena música, con un ambiente premium y chill, al tiempo que transmite a nuestros clientes el mejor confort a la hora de comer y disfrutar de cócteles de autor.'
    },
    {
        image: 'bg-tacos',
        name: 'GASTRONOMIA',
        description: 'Nuestros platos están inspirados en diferentes culturas como la mexicana y mediterránea, de donde provienen una mezcla de sabores e infusiones únicas logrando una propuesta gastronómica excepcional en el magdalena medio.'
    },
     {
        image: 'bg-emperador',
        name: 'MIXOLOGIA',
        description: 'Manejamos una mixología clásica y natural que nos ha posicionado como uno de los mejores bares de la región; implementando sabores frutales únicos con mezclas de especias logrando infusiones dulces y aromáticas de donde se inspiraron diferentes cocteles de autor.'
    },
    {
        image: 'bg-beerKolozo',
        name: 'UBICACIÓN',
        description: 'Nuestro gastrobar se encuentra en el centro de la dorada caldas en una terraza con vista al rio magdalena, el rio más importante y largo  de Colombia, aportando un ambiente fresco y acogedor.'
    }
];